import { render } from "./FullRoom.vue?vue&type=template&id=33946332&scoped=true"
import script from "./FullRoom.vue?vue&type=script&lang=js"
export * from "./FullRoom.vue?vue&type=script&lang=js"

import "./FullRoom.vue?vue&type=style&index=0&id=33946332&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-33946332"

export default script